var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"client-display submain-div"},[_c('div',[_vm._v(" 客户介绍,软件安装照片下面客户照片 ")]),_c('div',{staticClass:"dispaly-item"},[_c('img',{attrs:{"src":require("../../assets/img/valencia1.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }